import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const SwitchDim = ({ currMapData, currentMapTypeIndex }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currDim, setCurrDim] = useState(0)
  const toggleDim = (path) => {
    // navigate(path)
    window.open(path, '_blank')
  }
  useEffect(()=>{
    setCurrDim(location.pathname.includes("maps3d")?1:0)
  }, [location.pathname])
  return (

          <button className="btn btn-dark btn-lg" style={{backgroundColor:currDim===1?"grey":"", fontSize:12}} onClick={() => toggleDim(`/dashboard/maps3d?path=${currMapData.root}/${currMapData.modelPath[currentMapTypeIndex]}&id=${currMapData.id}`)} >3D</button>
  )
}

export default SwitchDim
